export enum RegistrationStatus {
  NotRegistered = '0',
  PreRegistrationComplete = '1',
  Registered = '2',
}
